<template>
    <div>
        <div class="checkboxes">
            <!-- Checkboxes -->
            <input id="all_reviews" v-model="params.phase" name="type" type="radio" value="all" />
            <label class="radio-label__full" for="all_reviews">
                <strong>
                    <div class="checkbox-text">{{ __('All ratings') }}</div>
                </strong>
            </label>

            <input id="call_reviews" v-model="params.phase" name="type" type="radio" value="call" />
            <label class="radio-label__full" for="call_reviews">
                <strong>
                    <div class="checkbox-text">{{ __('Call rating') }}</div>
                </strong>
            </label>

            <input id="3_months_reviews" v-model="params.phase" name="type" type="radio" value="after_3_months" />
            <label class="radio-label__full" for="3_months_reviews">
                <strong>
                    <div class="checkbox-text">{{ __('Evaluation after 3 months') }}</div>
                </strong>
            </label>
        </div>
        <div class="matrix-filter">
            <div class="filter-sort">
                <span>{{ __('Sort by') }}</span>

                <form action="#">
                    <button
                        v-for="option in sortOptions"
                        :class="{ active: params.sort === option.name }"
                        type="button"
                        @click="params.sort = option.name"
                    >
                        <span>{{ __(option.title) }}</span>
                    </button>
                </form>
            </div>

            <div class="filter-search">
                <form action="" autocomplete="off">
                    <button type="submit">
                        <svg-icon icon="search-icon-app" />
                    </button>

                    <button v-show="params.search" class="filter-remove" type="button" @click.prevent="params.search = ''">
                        <span class="material-icons-round">close</span>
                    </button>

                    <input v-model="params.search" :placeholder="__('Find a patient')" name="search" type="text" />
                </form>
            </div>
        </div>
        <div>
            <!-- Table -->
            <div v-if="loading" class="loader-wrapper">
                <img src="/imgs/vitadio-loader.svg" alt="">
            </div>

            <div v-else-if="reviews.length > 0" class="matrix-panel">
                <div class="table-layout table-patient table-clinical">
                    <div class="table-head head-fixed">
                        <div class="table-tr">
                            <div class="table-th cell-patient">{{ __('Patient') }}</div>
                            <div class="table-th cell-review">{{ __('Rating') }}</div>
                            <div class="table-th cell-word-review">{{ __('Written evaluation') }}</div>
                            <div class="table-th cell-type">{{ __('Type') }}</div>
                        </div>
                    </div>
                    <div class="table-body">
                        <div v-for="review in reviews" :key="review.id" class="table-tr">
                            <div class="table-td cell-patient">
                                <!-- <a :href="`/patient/${review.patient.id}`"> -->
                                <div class="profile">
                                    <UserAvatar :user-info="review.patient.user" size="xs" />

                                    <div class="profile-name">
                                        {{ review.patient.user.fullname }}
                                    </div>
                                </div>
                                <!-- </a> -->
                            </div>
                            <div class="table-td cell-review">
                                <div class="score-review">
                                    <strong v-if="review.score < 5" class="indicator-red">{{ review.score }}</strong>
                                    <strong v-else-if="review.score > 7" class="indicator-green">{{review.score }}</strong>
                                    <strong v-else class="indicator-orange">{{ review.score }}</strong>
                                    <div class="score-review-panel">
                                        <span :style="{ width: 'calc(' + review.score + '*10%)' }" class="score-review-value"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="table-td cell-word-review tooltip">
                                <div>
                                    <p>
                                        {{ review.phase === 'call' ? review.note : review.message }}
                                    </p>

                                    <div class="detail-full-reviews">
                                        <a class="detail-full-review" href="#">
                                            {{ __('View full detail') }}
                                            <div class="tooltip-content">
                                                <div class="profile">
                                                    <UserAvatar :user-info="review.patient.user" size="xs" />

                                                    <div class="profile-name">
                                                        <strong>{{ review.patient.user.fullname }}</strong>
                                                        <div class="detail-review-contact">
                                                            {{ review.patient.user.email }}, {{ review.patient.phone }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="detail-review-text">
                                                    <strong>{{ __('Written evaluation') }}</strong>
                                                </div>
                                                <div class="detail-review-text">
                                                    {{ review.phase === 'call' ? review.note : review.message }}
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="review.phase === 'call'" class="table-td cell-type">
                                <figure class="user-img">
                                    <span class="material-icons">phone</span>
                                </figure>
                                {{ __('Call') }}
                            </div>

                            <div v-else-if="review.phase === 'after_3_months'" class="table-td cell-type">
                                <figure class="user-img">
                                    3m
                                </figure>
                                {{ __('3 months') }}
                            </div>

                        </div>
                    </div>
                </div>
                <div style="padding: 20px;">
                    <a
                        v-if="showMoreButton"
                        class="btn btn-center btn-inverse btn-wide"
                        @click.prevent="fetch"
                    >
                        <span>{{ __('Load more ratings') }}</span>
                    </a>
                </div>
            </div>

            <div v-else class="no-data">
                <figure>
                    <svg-icon icon="icon-no-data"></svg-icon>
                </figure>
                <p>{{ __("No records") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { objToQueryString } from '@/helpers'

export default {
    props: {
        coach: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sortOptions: [
                { name: 'newest', title: lang.get('Latest') },
                { name: 'oldest', title: lang.get('Oldest') },
                { name: 'best', title: lang.get('Highest') },
                { name: 'worst', title: lang.get('Lowest') }
            ],
            params: {
                sort: 'newest',
                phase: 'all',
                search: ''
            },
            reviews: [],
            page: 1,
            showMoreButton: false,
            fetchTimeout: -1,
            loading: true
        }
    },
    watch: {
        params: {
            handler() {
                clearTimeout(this.fetchTimeout)

                this.fetchTimeout = setTimeout(() => {
                    this.page = 1
                    this.reviews = []
                    this.fetch()
                }, 300)
            },
            deep: true
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        async fetch() {
            if (this.page === -1) {
                return
            }

            const params = objToQueryString({ ...this.params, page: this.page })

            const reviews = await axios.get(`/coaches/${this.coach.id}/reviews?${params}`).thenData()

            if (reviews.length < 10) {
                this.page = -1
                this.showMoreButton = false
            } else {
                this.page++
                this.showMoreButton = true
            }

            if (reviews.length) {
                this.reviews.push(...reviews)
            }

            await this.$nextTick()
            
            this.loading = false
        },
    }
}
</script>
